export const imports = {
  'src/__docs__/customize.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-customize" */ 'src/__docs__/customize.mdx'
    ),
  'src/__docs__/design.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-design" */ 'src/__docs__/design.mdx'
    ),
  'src/__docs__/etc.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-etc" */ 'src/__docs__/etc.mdx'
    ),
  'src/__docs__/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-index" */ 'src/__docs__/index.mdx'
    ),
  'src/__docs__/inversion-of-control.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-inversion-of-control" */ 'src/__docs__/inversion-of-control.mdx'
    ),
  'src/base/__docs__/badge.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-base-docs-badge-docs" */ 'src/base/__docs__/badge.docs.mdx'
    ),
  'src/base/__docs__/generic.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-base-docs-generic-docs" */ 'src/base/__docs__/generic.docs.mdx'
    ),
  'src/base/__docs__/tooltip.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-base-docs-tooltip-docs" */ 'src/base/__docs__/tooltip.docs.mdx'
    ),
  'src/components/breadcrumb/__docs__/breadcrumb.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-breadcrumb-docs-breadcrumb-docs" */ 'src/components/breadcrumb/__docs__/breadcrumb.docs.mdx'
    ),
  'src/components/card/__docs__/card.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-card-docs-card-docs" */ 'src/components/card/__docs__/card.docs.mdx'
    ),
  'src/components/dropdown/__docs__/dropdown.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-dropdown-docs-dropdown-docs" */ 'src/components/dropdown/__docs__/dropdown.docs.mdx'
    ),
  'src/components/level/__docs__/level.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-level-docs-level-docs" */ 'src/components/level/__docs__/level.docs.mdx'
    ),
  'src/components/list/__docs__/list.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-list-docs-list-docs" */ 'src/components/list/__docs__/list.docs.mdx'
    ),
  'src/components/media/__docs__/media.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-media-docs-media-docs" */ 'src/components/media/__docs__/media.docs.mdx'
    ),
  'src/components/menu/__docs__/menu.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-menu-docs-menu-docs" */ 'src/components/menu/__docs__/menu.docs.mdx'
    ),
  'src/components/message/__docs__/message.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-message-docs-message-docs" */ 'src/components/message/__docs__/message.docs.mdx'
    ),
  'src/components/modal/__docs__/modal.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-modal-docs-modal-docs" */ 'src/components/modal/__docs__/modal.docs.mdx'
    ),
  'src/components/navbar/__docs__/navbar.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-navbar-docs-navbar-docs" */ 'src/components/navbar/__docs__/navbar.docs.mdx'
    ),
  'src/components/pagination/__docs__/pagination.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-pagination-docs-pagination-docs" */ 'src/components/pagination/__docs__/pagination.docs.mdx'
    ),
  'src/components/panel/__docs__/panel.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-panel-docs-panel-docs" */ 'src/components/panel/__docs__/panel.docs.mdx'
    ),
  'src/components/tab/__docs__/tab.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-components-tab-docs-tab-docs" */ 'src/components/tab/__docs__/tab.docs.mdx'
    ),
  'src/elements/box/__docs__/box.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-box-docs-box-docs" */ 'src/elements/box/__docs__/box.docs.mdx'
    ),
  'src/elements/button/__docs__/button.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-button-docs-button-docs" */ 'src/elements/button/__docs__/button.docs.mdx'
    ),
  'src/elements/container/__docs__/container.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-container-docs-container-docs" */ 'src/elements/container/__docs__/container.docs.mdx'
    ),
  'src/elements/form/__docs__/checkbox.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-checkbox-docs" */ 'src/elements/form/__docs__/checkbox.docs.mdx'
    ),
  'src/elements/form/__docs__/file.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-file-docs" */ 'src/elements/form/__docs__/file.docs.mdx'
    ),
  'src/elements/form/__docs__/form.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-form-docs" */ 'src/elements/form/__docs__/form.docs.mdx'
    ),
  'src/elements/form/__docs__/input.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-input-docs" */ 'src/elements/form/__docs__/input.docs.mdx'
    ),
  'src/elements/form/__docs__/radio.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-radio-docs" */ 'src/elements/form/__docs__/radio.docs.mdx'
    ),
  'src/elements/form/__docs__/select.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-select-docs" */ 'src/elements/form/__docs__/select.docs.mdx'
    ),
  'src/elements/form/__docs__/textarea.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-form-docs-textarea-docs" */ 'src/elements/form/__docs__/textarea.docs.mdx'
    ),
  'src/elements/content/__docs__/content.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-content-docs-content-docs" */ 'src/elements/content/__docs__/content.docs.mdx'
    ),
  'src/elements/icon/__docs__/icon.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-icon-docs-icon-docs" */ 'src/elements/icon/__docs__/icon.docs.mdx'
    ),
  'src/elements/notification/__docs__/notification.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-notification-docs-notification-docs" */ 'src/elements/notification/__docs__/notification.docs.mdx'
    ),
  'src/elements/other/__docs__/other.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-other-docs-other-docs" */ 'src/elements/other/__docs__/other.docs.mdx'
    ),
  'src/elements/image/__docs__/image.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-image-docs-image-docs" */ 'src/elements/image/__docs__/image.docs.mdx'
    ),
  'src/elements/page-loader/__docs__/page-loader.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-page-loader-docs-page-loader-docs" */ 'src/elements/page-loader/__docs__/page-loader.docs.mdx'
    ),
  'src/elements/progress/__docs__/progress.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-progress-docs-progress-docs" */ 'src/elements/progress/__docs__/progress.docs.mdx'
    ),
  'src/elements/table/__docs__/table.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-table-docs-table-docs" */ 'src/elements/table/__docs__/table.docs.mdx'
    ),
  'src/elements/tag/__docs__/tag.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-tag-docs-tag-docs" */ 'src/elements/tag/__docs__/tag.docs.mdx'
    ),
  'src/elements/title/__docs__/title.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-elements-title-docs-title-docs" */ 'src/elements/title/__docs__/title.docs.mdx'
    ),
  'src/grid/columns/__docs__/columns.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-grid-columns-docs-columns-docs" */ 'src/grid/columns/__docs__/columns.docs.mdx'
    ),
  'src/grid/tiles/__docs__/tile.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-grid-tiles-docs-tile-docs" */ 'src/grid/tiles/__docs__/tile.docs.mdx'
    ),
  'src/layout/divider/__docs__/divider.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-layout-divider-docs-divider-docs" */ 'src/layout/divider/__docs__/divider.docs.mdx'
    ),
  'src/layout/footer/__docs__/footer.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-layout-footer-docs-footer-docs" */ 'src/layout/footer/__docs__/footer.docs.mdx'
    ),
  'src/layout/hero/__docs__/hero.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-layout-hero-docs-hero-docs" */ 'src/layout/hero/__docs__/hero.docs.mdx'
    ),
  'src/layout/section/__docs__/section.docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-layout-section-docs-section-docs" */ 'src/layout/section/__docs__/section.docs.mdx'
    ),
}
